import { useEffect, useState, useRef } from "react"
import { Button } from "primereact/button"
import ServiceRegistrationDialog from "./ServiceRegistrationDialog"
import { createPortal } from "react-dom"

function AnotherBtn({onClick}){
    return (
        <button onClick={onClick} className="js-tran" >
            <div className="btn-container">
                <span className="js-text">Запись на сервис</span>
            </div>                  
        </button>
    )
}

export default function ServiceRegistrationButton(){
    const [showDialog, setShowDialog] = useState(false)
    const onHide = () => setShowDialog(false)
    
    const targetRef2 = useRef(document.getElementById('root-service-regitration-2'));
    const targetRef3 = useRef(document.getElementById('root-service-regitration-3'));

    

    // useEffect(() => {
    //     const targetNode2 = targetRef2.current;
    //     if(targetNode2){
    //         targetNode2.innerHTML = '';
    //         // createPortal(<AnotherBtn key={'btn-2'} onClick={(e) => setShowDialog(true)} />, targetNode2)
    //     }

    //     const targetNode3 = targetRef3.current;
    //     if(targetNode3){
    //         targetNode3.innerHTML = '';
            
    //     }

    // }, [])

    return (
        <>
        <Button onClick={(e) => setShowDialog(true)} className="btn btn-primary w-full" style={{backgroundColor: '#009846'}} >Запись на сервис</Button>
        {targetRef2.current ? createPortal(<AnotherBtn key={'btn-2'} onClick={(e) => setShowDialog(true)} />, targetRef2.current) : null}            
        {targetRef3.current ? createPortal(<AnotherBtn key={'btn-3'} onClick={(e) => setShowDialog(true)} />, targetRef3.current) : null}            
        {
            showDialog
            ?
            <ServiceRegistrationDialog onHide={onHide} />
            :
            null
        }
        </>

    )
}